import React, { useEffect } from "react";
import Footer from "../../shared/Footer/Footer";
import Navbar from "../../shared/Navbar/Navbar";
import "../../../style/resource/photoGallery.css";
import imageOne from "../../../images/Gallery/1.jpg";
import imagetwo from "../../../images/Gallery/2.jpg";
import imageThree from "../../../images/Gallery/3.jpg";
import imageFour from "../../../images/Gallery/4.jpg";
import imageFive from "../../../images/Gallery/5.jpg";
import imageSix from "../../../images/Gallery/6.jpg";
import imageSeven from "../../../images/Gallery/7.jpg";
import imageEight from "../../../images/Gallery/8.jpg";
import imageNine from "../../../images/Gallery/9.jpg";
import TranslateButton from "../../TranslateButton/TranslateButton";

const PhotoGallery = () => {
  useEffect(() => {
    document.title = `Development Concern | Photo Gallery`;
  }, []);

  return (
    <>
      <Navbar />
      {/* <TranslateButton /> */}
      <div className="gallery_section">
        <div className="header_image">
          <p>Home | Resources</p>
          <h2>Photo Gallery</h2>
        </div>

        <div className="container">
          <h1>Photo Gallery </h1>

          <div className="content_wrapper">

            <div className="single_image_wrapper">
              <img src={imageOne} alt="" />
              <div className="caption">
                <span>
                  A meeting held for International Literacy Day in Rangamati District Office
                </span>
              </div>
            </div>

            <div className="single_image_wrapper">
              <img src={imagetwo} alt="" />
              <div className="caption">
                <span>
                  A meeting held for International Literacy Day in Rangamati District Office
                </span>
              </div>
            </div>

            <div className="single_image_wrapper">
              <img src={imageThree} alt="" />
              <div className="caption">
                <span>
                  A meeting held for International Literacy Day in Rangamati District Office
                </span>
              </div>
            </div>

            <div className="single_image_wrapper">
              <img src={imageFour} alt="" />
              <div className="caption">
                <span>
                  A meeting held for International Literacy Day in Rangamati District Office
                </span>
              </div>
            </div>

            <div className="single_image_wrapper">
              <img src={imageFive} alt="" />
              <div className="caption">
                <span>
                  A meeting held for International Literacy Day in Rangamati District Office
                </span>
              </div>
            </div>

            <div className="single_image_wrapper">
              <img src={imageSix} alt="" />
              <div className="caption">
                <span>
                  A meeting held for International Literacy Day in Rangamati District Office
                </span>
              </div>
            </div>

            <div className="single_image_wrapper">
              <img src={imageSeven} alt="" />
              <div className="caption">
                <span>
                  A meeting held for International Literacy Day in Rangamati District Office
                </span>
              </div>
            </div>

            <div className="single_image_wrapper">
              <img src={imageEight} alt="" />
              <div className="caption">
                <span>
                  A meeting held for International Literacy Day in Rangamati District Office
                </span>
              </div>
            </div>

            <div className="single_image_wrapper">
              <img src={imageNine} alt="" />
              <div className="caption">
                <span>
                  A meeting held for International Literacy Day in Rangamati District Office
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default PhotoGallery;
